var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-icon"},[_c('img',{staticClass:"icon",attrs:{"src":_vm.icon}}),_c('input',{attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"name":_vm.name},domProps:{"value":_vm.value},on:{"input":_vm.onChangeText}})])}
var staticRenderFns = []

export { render, staticRenderFns }